import React from 'react';
import { HStack, Tag } from '@cardboard-ui/react';
import { EditableFolderItemMenu } from 'components/Folder/FolderNodeOptionsMenu/EditableFolderItemMenu';
import { graphql, useFragment } from 'utils/graphClient';
import {
  Status_node$data,
  Status_node$key,
} from './__generated__/Status_node.graphql';
import { t } from '@lingui/macro';

const nodeFragment = graphql`
  fragment Status_node on Node {
    __typename
    id
    ... on VaultItem {
      cover
    }
    ... on IsNewInterface {
      isNew
    }
    ... on FolderNode {
      ...EditableFolderItemMenu_folderItemNode
    }
  }
`;

type StatusProps = {
  node: Status_node$key;
  isUpdatingPage?: boolean;
};

export const Status = ({ node: _node, isUpdatingPage }: StatusProps) => {
  const node = useFragment(nodeFragment, _node);

  return (
    <>
      <HStack spacing={1}>
        <NewState node={node} isUpdatingPage={isUpdatingPage} />
        <CoverState node={node} isUpdatingPage={isUpdatingPage} />
      </HStack>
      <StatusButton node={node} isUpdatingPage={isUpdatingPage} />
    </>
  );
};

interface InnerProps {
  node: Status_node$data;
  isUpdatingPage?: boolean;
}

const StatusButton = ({ node, isUpdatingPage }: InnerProps) => {
  switch (node.__typename) {
    case 'FolderItem':
      return (
        <EditableFolderItemMenu
          fragment={node}
          isUpdatingPage={!!isUpdatingPage}
        />
      );
  }

  return null;
};

const CoverState = ({ node, isUpdatingPage }: InnerProps) => {
  if (node.cover) {
    return (
      <Tag colorScheme="green" size="md" variant="solid">
        {t`Cover`}
      </Tag>
    );
  }

  return null;
};

const NewState = ({ node, isUpdatingPage }: InnerProps) => {
  return node.isNew ? <NewTag /> : null;
};

const NewTag = () => (
  <Tag colorScheme="green" size="md" variant="outline">
    {t`New`}
  </Tag>
);
